export default class Passenger {
  flightId: string;
  passengerType: number;
  gender: string;
  name: string;
  surname: string;
  birthday: string;
  passportNumber: string;
  nationality: string;
  passportExpireDate: string;
  passportSerial: string;
  flightClassId: string;
  flightClass: string;
  flightClassName: string;
  price: number;
  flightSegmentId: string;
  direction: number;
  rowNumber: string;
  passengers: any[];
}
